import {Component} from '@angular/core';
/**
 * \@title Datepicker Filter
 */
export class DatepickerFilterExample {
  myFilter = (d: Date): boolean => {
    const /** @type {?} */ day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-filter-example',
  templateUrl: 'datepicker-filter-example.html',
  styleUrls: ['datepicker-filter-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerFilterExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerFilterExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerFilterExample.ctorParameters;
/** @type {?} */
DatepickerFilterExample.prototype.myFilter;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
